import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import './routeguard'


import '@/assets/theme/index.css'
import ElementUI from 'element-ui'
Vue.use(ElementUI)


// 加载富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);


// setting全局设置
Vue.config.debug = true
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })



// WEBPACK FOOTER //
// ./src/main.js